// @vendors
const get = require('lodash/object/get');
const moment = require('moment');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');
const { CARD_STATE_FILTER_DEFERRED, DATE_FORMAT_API } = require('constants/index');
// We get movements from last 6 months if no dates are selected for the filter
const DEFAULT_CARD_TRANSACTION_FROM = 6;
const DEFAULT_CARD_TRANSACTION_FROM_UNIT = 'months';
const { PFM_NEW_FEATURES ,NOT_ALLOWED_CARDS_SEARCH_AND_AMOUNT_FILTERS_COUNTRIES} = require('constants/flagBasedFeatures');


const loginData = cardId => ({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_REQUEST,
    payload: {
        cardId
    }
});

const requestCardTransactionsSuccess = (data, cardId) => ({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_SUCCESS,
    payload: {
        cardId,
        nextPage: get(data, 'finLista', '') === 'N',
        movements: get(data, 'lista.movimientos', []),
        repagination: {
            dayRepo: get(data, 'repo.diaRepo', 0),
            currencyRepo: get(data, 'repo.divisaRepo', ''),
            anotationMovDateRepo: get(data, 'repo.fechaAnotacionMovRepo', ''),
            operationDateRepo: get(data, 'repo.fechaOperacionRepo', ''),
            indPosCursorRepo: get(data, 'repo.indPosCursorRepo', ''),
            balanceTypeRepo: get(data, 'repo.tipoSaldoRepo', '')
        },
        scaRequired: !__CONTACT_CENTER__ ? get(data, 'scaRequired', false) : false,
        monthsBefore: data?.filterCards[0]?.monthsBefore || DEFAULT_CARD_TRANSACTION_FROM,
    }
});

const requestNextCardTransactionsPageRequest = cardId => ({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_PAGE_REQUEST,
    payload: {
        cardId
    }
});

const requestNextCardTransactionsPageSuccess = (data, cardId) => ({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_PAGE_SUCCESS,
    payload: {
        cardId,
        nextPage: get(data, 'finLista', '') === 'N',
        movements: get(data, 'lista.movimientos', []),
        repagination: {
            dayRepo: get(data, 'repo.diaRepo', 0),
            currencyRepo: get(data, 'repo.divisaRepo', ''),
            anotationMovDateRepo: get(data, 'repo.fechaAnotacionMovRepo', ''),
            operationDateRepo: get(data, 'repo.fechaOperacionRepo', ''),
            indPosCursorRepo: get(data, 'repo.indPosCursorRepo', ''),
            balanceTypeRepo: get(data, 'repo.tipoSaldoRepo', '')
        },
        scaRequired: !__CONTACT_CENTER__ ? get(data, 'scaRequired', false) : false,
    }
});

const requestCardTransactionFailure = (data, cardId) => ({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_FAILURE,
    payload: {
        cardId,
        data,
        monthsBefore: DEFAULT_CARD_TRANSACTION_FROM,
    }
});

const setTransactionsFilters = (filters) => ({
    type: actionTypes.CARDS_TRANSACTIONS_SET_FILTERS,
    payload: {
        filters
    }
});

const cardTransactionsOutdated = () => ({
    type: actionTypes.CARDS_TRANSACTIONS_OUTDATED
});

const resetCardTransactionsFilter = filterKey => ({
    type: actionTypes.RESET_CARD_TRANSACTIONS_FILTER,
    payload: {
        filterKey
    }
});

const requestClearCardTransactionsFilters = () => ({
    type: actionTypes.FETCH_CARD_TRANSACTIONS_FILTERS_CLEAR
});

const requestClearCardTransactionsFiltersNoRecord = () => ({
    type: actionTypes.FETCH_CARD_TRANSACTIONS_FILTERS_CLEAR_NO_RECORD
});

const clearCardTransactionsFilters = (recordProcess = true) => dispatch => {
    if(recordProcess) {
        dispatch(requestClearCardTransactionsFilters());
    } else {
        dispatch(requestClearCardTransactionsFiltersNoRecord());
    }
    dispatch(cardTransactionsOutdated());
}

const updateCardTransactionCategory = (cardId, transactionId, category, subcategory) => ({
    type: actionTypes.CARDS_TRANSACTIONS_CHANGE_CATEGORY,
    payload: {
        cardId,
        transactionId,
        category,
        subcategory
    }
});

const requestCardTransactions = cardId => (dispatch, getState) => {
    const immDateFilter = getState().cardsTransactions.getIn(['filters', 'date']);
    const immSituationFilter = getState().cardsTransactions.getIn(['filters', 'situation']);
    const immStateFilter = getState().cardsTransactions.getIn(['filters', 'state']);
    const immCardContract = getState().cards.getIn(['byId', cardId, 'contract']);
    const immTextFilter = getState().cardsTransactions.getIn(['filters', 'description']);
    const minAmountFilter = getState().cardsTransactions.getIn(['filters','amount','from','amount']);
    const maxAmountFilter = getState().cardsTransactions.getIn(['filters','amount','to','amount']);
    const isAmountAndTextFilter = getState().cardsTransactions.getIn(['filters','amount','isActive']);
    const panNumber = getState().cards.getIn(['byId', cardId, 'number']);
    const hasNewPFMFeaturesFF = getState().flagBasedFeatures ?  getState().flagBasedFeatures.get(PFM_NEW_FEATURES) : false;
    const defaultFromField = moment()
        .startOf('day')
        .subtract(DEFAULT_CARD_TRANSACTION_FROM, DEFAULT_CARD_TRANSACTION_FROM_UNIT);
    const dateFrom = immDateFilter.get('from') || defaultFromField;
    const dateTo = immDateFilter.get('to') || moment().startOf('day');
    
    const allowedAccountFF = getState().flagBasedFeatures ?  getState().flagBasedFeatures.get(NOT_ALLOWED_CARDS_SEARCH_AND_AMOUNT_FILTERS_COUNTRIES) : false;
  
    const params = {
        header: {
            version: hasNewPFMFeaturesFF || allowedAccountFF ? 4 : 2
        },
        query: {
            pan: panNumber,
            producto: immCardContract.get('product'),
            numeroContrato: immCardContract.get('number'),
            fechaDesde: dateFrom.format(DATE_FORMAT_API),
            fechaHasta: dateTo.format(DATE_FORMAT_API),

            ...(immStateFilter.get('isActive') && { filtroIndPagoFacil: immStateFilter.get('selected') } || {}),
            ...(immSituationFilter.get('isActive') && { filtroSituacionOperacion: immSituationFilter.get('selected') } || {}),
            ...(immTextFilter.get('isActive') && { descripcion: immTextFilter.get('selected') } || {}),
            ...(isAmountAndTextFilter && { minImporte: minAmountFilter,maxImporte: maxAmountFilter } || {}),

        }
    };

    dispatch(loginData(cardId));

    return APIPost({
        dispatch,
        params,
        endpoint: 'cardTransactions'
    })
        .then(response => dispatch(requestCardTransactionsSuccess(response, cardId)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestCardTransactionFailure(response.error, cardId));
            } else throw response;
        });
};

const requestCardDeferredTransactions = (cardId) => (dispatch, getState) => {
    const filtersForDeferred = getState().cardsTransactions.get('filters')
        .merge({
            state: {
                isActive: true,
                selected: CARD_STATE_FILTER_DEFERRED,
            }
        }).toJS();
    dispatch(setTransactionsFilters(filtersForDeferred));
    dispatch(requestCardTransactions(cardId));
};
const requestNextCardTransactionsPage = cardId => (dispatch, getState) => {
    dispatch(requestNextCardTransactionsPageRequest(cardId));

    const panNumber = getState().cards.getIn(['byId', cardId, 'number']);
    const immCardContract = getState().cards.getIn(['byId', cardId, 'contract']);
    const immTextFilter = getState().cardsTransactions.getIn(['filters', 'description']);
    const minAmountFilter = getState().cardsTransactions.getIn(['filters','amount','from','amount']);
    const maxAmountFilter = getState().cardsTransactions.getIn(['filters','amount','to','amount']);
    const isAmountAndTextFilter = getState().cardsTransactions.getIn(['filters','amount','isActive']);
    const immDateFilter = getState().cardsTransactions.getIn(['filters', 'date']);
    const immSituationFilter = getState().cardsTransactions.getIn(['filters', 'situation']);
    const immStateFilter = getState().cardsTransactions.getIn(['filters', 'state']);
    const defaultFromField = moment().startOf('day').subtract(DEFAULT_CARD_TRANSACTION_FROM, DEFAULT_CARD_TRANSACTION_FROM_UNIT);
    const dateFrom = immDateFilter.get('from') || defaultFromField;
    const dateTo = immDateFilter.get('to') || moment().startOf('day');
    const immRepo = getState().cardsTransactions.getIn([cardId, 'repagination']);
    const hasNewPFMFeaturesFF = getState().flagBasedFeatures ?  getState().flagBasedFeatures.get(PFM_NEW_FEATURES) : false;
    const allowedAccountFF = getState().flagBasedFeatures ?  getState().flagBasedFeatures.get(NOT_ALLOWED_CARDS_SEARCH_AND_AMOUNT_FILTERS_COUNTRIES) : false;

    const params = {
        header: {
            version: hasNewPFMFeaturesFF || allowedAccountFF ? 4 : 2
        },
        query: {
            diaRepo: immRepo.get('dayRepo'),
            divisaRepo: immRepo.get('currencyRepo'),
            fechaAnotacionMovRepo: immRepo.get('anotationMovDateRepo'),
            fechaDesde: dateFrom.format(DATE_FORMAT_API),
            fechaHasta: dateTo.format(DATE_FORMAT_API),
            fechaOperacionRepo: immRepo.get('operationDateRepo'),
            indPosCursorRepo: immRepo.get('indPosCursorRepo'),
            indRepo: 'R',
            numeroContrato: immCardContract.get('number'),
            pan: panNumber,
            producto: immCardContract.get('product'),
            tipoSaldoRepo: immRepo.get('balanceTypeRepo'),
            ...(immStateFilter.get('isActive') && { filtroIndPagoFacil: immStateFilter.get('selected') } || {}),
            ...(immSituationFilter.get('isActive') && { filtroSituacionOperacion: immSituationFilter.get('selected') } || {}),
            ...(immTextFilter.get('isActive') && { descripcion: immTextFilter.get('selected') } || {}),
            ...(isAmountAndTextFilter && { minImporte: minAmountFilter,maxImporte: maxAmountFilter } || {}),

        }
    };

    return APIPost({
        dispatch,
        endpoint: 'cardTransactions',
        params
    })
        .then(response => dispatch(requestNextCardTransactionsPageSuccess(response, cardId)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestCardTransactionFailure(response.error, cardId));
            } else throw response;
        });
};

module.exports = {
    cardTransactionsOutdated,
    clearCardTransactionsFilters,
    requestCardDeferredTransactions,
    requestCardTransactions,
    requestNextCardTransactionsPage,
    resetCardTransactionsFilter,
    setTransactionsFilters,
    updateCardTransactionCategory,
};
